import { Action } from "redux";
import { ConversacionesUsers, Mensajes } from "../../../types/chat/conversaciones/Conversaciones";

export const FETCH_CONVERSACIONES_USERS_REQUEST = 'FETCH_CONVERSACIONES_USERS_REQUEST';
export const FETCH_CONVERSACIONES_USERS_SUCCESS = 'FETCH_CONVERSACIONES_USERS_SUCCESS';
export const FETCH_CONVERSACIONES_USERS_FAILURE = 'FETCH_CONVERSACIONES_USERS_FAILURE';

export const FETCH_MENSAJES_CONVERSACION_REQUEST = 'FETCH_MENSAJES_CONVERSACION_REQUEST';
export const FETCH_MENSAJES_CONVERSACION_SUCCESS = 'FETCH_MENSAJES_CONVERSACION_SUCCESS';
export const FETCH_MENSAJES_CONVERSACION_FAILURE = 'FETCH_MENSAJES_CONVERSACION_FAILURE';

export const SET_NUEVO_MENSAJE_CONVERSACION = 'SET_NUEVO_MENSAJE_CONVERSACION';
export const SET_CONVERSACION_SELECCIONADA = 'SET_CONVERSACION_SELECCIONADA';
export const SET_UPDATE_LAST_MESSAGE = 'SET_UPDATE_LAST_MESSAGE';
export const SET_NUEVA_CONVERSACION = 'SET_NUEVA_CONVERSACION';

export const UPDATE_MENSAJE_CONVERSACION = 'UPDATE_MENSAJE_CONVERSACION';

export interface UpdateMensajeConversacionAction extends Action<typeof UPDATE_MENSAJE_CONVERSACION> {
  type: typeof UPDATE_MENSAJE_CONVERSACION;
  payload: Mensajes;
}

export interface SetNuevaConversacionAction extends Action<typeof SET_NUEVA_CONVERSACION> {
  type: typeof SET_NUEVA_CONVERSACION;
  payload: ConversacionesUsers;
}

export interface SetUpdateLastMessageAction extends Action<typeof SET_UPDATE_LAST_MESSAGE> {
  type: typeof SET_UPDATE_LAST_MESSAGE;
  payload: Mensajes;
}

export interface SetConversacionSeleccionadaRequestAction extends Action<typeof SET_CONVERSACION_SELECCIONADA> {
  type: typeof SET_CONVERSACION_SELECCIONADA;
  payload: ConversacionesUsers;
}

export interface SetNuevoMensajeConversacionAction extends Action<typeof SET_NUEVO_MENSAJE_CONVERSACION> {
  type: typeof SET_NUEVO_MENSAJE_CONVERSACION;
  payload: Mensajes;
}

export interface FetchConversacionesUsersRequestAction extends Action<typeof FETCH_CONVERSACIONES_USERS_REQUEST> {
  type: typeof FETCH_CONVERSACIONES_USERS_REQUEST;
}

export interface FetchConversacionesUsersSuccessAction extends Action<typeof FETCH_CONVERSACIONES_USERS_SUCCESS> {
  type: typeof FETCH_CONVERSACIONES_USERS_SUCCESS;
  payload: {
    data: ConversacionesUsers[],
    meta: any
  };
}

export interface FetchConversacionesUsersFailureAction extends Action<typeof FETCH_CONVERSACIONES_USERS_FAILURE> {
  type: typeof FETCH_CONVERSACIONES_USERS_FAILURE;
  payload: string;
}

export interface FetchMensajesConversacionRequestAction extends Action<typeof FETCH_MENSAJES_CONVERSACION_REQUEST> {
  type: typeof FETCH_MENSAJES_CONVERSACION_REQUEST;
}

export interface FetchMensajesConversacionSuccessAction extends Action<typeof FETCH_MENSAJES_CONVERSACION_SUCCESS> {
  type: typeof FETCH_MENSAJES_CONVERSACION_SUCCESS;
  payload: {
    data: Mensajes[],
    meta: any
  };
}

export interface FetchMensajesConversacionFailureAction extends Action<typeof FETCH_MENSAJES_CONVERSACION_FAILURE> {
  type: typeof FETCH_MENSAJES_CONVERSACION_FAILURE;
  payload: string;
}


export type EmpresasActionTypes =
  | FetchConversacionesUsersRequestAction
  | FetchConversacionesUsersSuccessAction
  | FetchConversacionesUsersFailureAction
  | FetchMensajesConversacionRequestAction
  | FetchMensajesConversacionSuccessAction
  | FetchMensajesConversacionFailureAction
  | SetConversacionSeleccionadaRequestAction
  | SetNuevoMensajeConversacionAction
  | UpdateMensajeConversacionAction
  | SetNuevaConversacionAction;